import React from 'react'

export const HistoryTableAsync = React.lazy(() => import('./history-table'))
